var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "singleDisbursementModal" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "diglog-card",
          attrs: {
            visible: _vm.dialogVisible,
            title: _vm.$t("data.delete_account"),
            "close-on-click-modal": false,
            width: "509px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "header-line" }),
          _c("div", { staticClass: "section-title" }, [
            _vm._v(" " + _vm._s(_vm.$t("data.confirm_delete")) + " "),
          ]),
          _c(
            "div",
            {
              staticClass: "section-tip",
              staticStyle: { "word-break": "keep-all" },
            },
            [_vm._v(" " + _vm._s(_vm.$t("tips.delete_account_tip")) + " ")]
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn-submit",
                  attrs: { type: "info", disabled: _vm.submiting },
                  on: { click: _vm.onClickSubmitBtn },
                },
                [_vm._v(_vm._s(_vm.$t("components.submit")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }